/**
 * API URLs for the web app.
 *
 * Production (www / game / etc.): relative `/v1`, `/home` — same host; nginx proxies to puzzle-be.
 * CRA local (`npm start`): `/v1` and `/home` via setupProxy; admin `/test/**` hits puzzle-be :8080.
 */
/** puzzle-be local origin — puzzle-be/docs/instagram-rest-api.md §1.1 */
const LOCAL_BACKEND_ORIGIN = "http://localhost:8080";

/** CRA dev: /v1 and /home go through setupProxy — keep base empty. */
export function isCraDevLocalProxy() {
    if (typeof window === "undefined") {
        return false;
    }
    const { hostname, port } = window.location;
    if (hostname !== "localhost" && hostname !== "127.0.0.1") {
        return false;
    }
    return port === "3000" || port === "3001";
}

/** Always same-origin (empty). Kept for callers that expect an origin string. */
export function getApiBaseUrl() {
    return "";
}

export function apiUrl(path) {
    if (path == null || typeof path !== "string") {
        return path;
    }
    if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
    }
    return path.startsWith("/") ? path : `/${path}`;
}

/**
 * Backend URL for admin `/test/**` and related calls.
 * In CRA dev, targets puzzle-be on :8080 directly (avoids 404 on the React dev server).
 * @param {string} path e.g. `/test/instagram/post-image`
 */
export function resolveBackendApiUrl(path) {
    if (path == null || typeof path !== "string") {
        return path;
    }
    if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
    }
    const q = path.indexOf("?");
    const pathOnly = q === -1 ? path : path.slice(0, q);
    const query = q === -1 ? "" : path.slice(q);
    const p = pathOnly.startsWith("/") ? pathOnly : `/${pathOnly}`;

    if (isCraDevLocalProxy()) {
        return `${LOCAL_BACKEND_ORIGIN}${p}${query}`;
    }
    return `${p}${query}`;
}

export function resolveApiFetchUrl(urlWithQuery) {
    if (urlWithQuery == null || typeof urlWithQuery !== "string") {
        return urlWithQuery;
    }
    if (urlWithQuery.startsWith("http://") || urlWithQuery.startsWith("https://")) {
        return urlWithQuery;
    }
    const q = urlWithQuery.indexOf("?");
    if (q === -1) {
        return apiUrl(urlWithQuery);
    }
    return apiUrl(urlWithQuery.slice(0, q)) + urlWithQuery.slice(q);
}
